module.exports = __webpack_public_path__ + "img/logo.ad93fe17.png";